import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { Router } from '@angular/router';
import { AppelsService } from '../../service/appels.service';
import { Chart, plugins } from 'chart.js';
import { CandidatureRequest } from 'src/app/model/CandidatureRequest.model';
import { NewCandidature } from 'src/app/model/NewCandidature';
import {
  FormBuilder,
  FormGroup,
  RequiredValidator,
  Validators,
} from '@angular/forms';
import { TableUtil } from 'src/app/utils/TableExport/TableUtili';
import { MatTabsModule } from '@angular/material/tabs';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-sigui-appels',
  templateUrl: './sigui-appels.component.html',
  styleUrls: ['./sigui-appels.component.css'],
})
export class SIGUIAppelsComponent implements OnInit, OnDestroy, AfterViewInit {
  lotsOfTabs = new Array(30).fill(0).map((_, index) => `Tab ${index}`);
  // lotsOfTabs : {name:string}[]=[];

  @ViewChild('canvasGender', { static: false })
  canvasGender!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasNationality', { static: false })
  canvasNationality!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasStatus', { static: false })
  canvasStatus!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasStatusVertical', { static: false })
  canvasStatusVertical!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasLevel', { static: false })
  canvasLevel!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasRightHandicap', { static: false })
  canvasRightHandicap!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasFamily', { static: false })
  canvasFamily!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasForceNKnow', { static: false })
  canvasForceNKnow!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasCertified', { static: false })
  canvasCertified!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasProjetIssu', { static: false })
  canvasProjetIssu!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasRightStatus', { static: false })
  canvasRightStatus!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasHightDiplome', { static: false })
  canvasHightDiplome!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasSeriebac', { static: false })
  canvasSeriebac!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasDesciDutBts', { static: false })
  canvasDesciDutBts!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasDesciLicenceMaster', { static: false })
  canvasDesciLicenceMaster!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasDisponible', { static: false })
  canvasDisponible!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasRegion', { static: false })
  canvasRegion!: ElementRef<HTMLCanvasElement>;

  showSpinner = false;
  firstPage: boolean = false;
  secondePage: boolean = false;
  thirdPase: boolean = false;
  currentPage = 1;
  cohorteFrom!: any;
  formGroup!: FormGroup;
  recuCohorte!: string;
  showActiveModal: boolean = false;
  showDesactiveModal: boolean = false;
  listeCohortes: string[] = [];
  active!: boolean;
  tableExportOfStats: { name: string; value: number }[] = [];
  theButton: { name: string; value: number }[] = [];

  // tableExportOfStats: any[] =[];

  //for statics
  homme!: any;
  femme!: any;
  senegal!: any;
  autre!: any;
  dimplomeWithoutEmployedCount!: any;
  autreStatus!: any;
  studentCount!: any;
  //destroy
  chartNationality!: any;
  chartStatus!: any;
  chartGender!: any;
  chartLevel!: any;
  chartRightStatus!: any;
  chartFamily!: any;
  chartKnow!: any;
  chartCertified!: any;
  chartProjet!: any;
  chartHightDiplome!: any;
  chartBacSerie!: any;
  chartDesciDutBts!: any;
  chartDesciMasterLicence!: any;
  chartDisponible!: any;
  chartRegion!: any;
  chartStatusVertical!: any;

  //Level
  licence1Level!: any;
  licence2Level!: any;
  licence3Level!: any;
  master1Level!: any;
  master2Level!: any;
  doctorantLevel!: any;
  autreLevel!: any;

  //right handicap
  handicaps_visuel!: any;
  handicaps_auditif!: any;
  handicaps_moteur!: any;
  handicaps_autre!: any;

  //familly
  DevLogi!: any;
  eBusiness!: any;
  cca!: any;
  techEmergentCys!: any;
  IntelligenceArtiData!: any;

  //ForceN know
  reseau!: any;
  siteWeb!: any;
  boucheOreille!: any;
  TvRadio!: any;
  presse!: any;
  siteWebpartenaire!: any;
  autreKnow!: any;

  //FirceN certified
  certified!: any;
  noCertified!: any;

  //projet issu
  poursuivreEtude!: any;
  lancerEntreprise!: any;
  chercheEmploi!: any;
  retourEntreprise!: any;
  aucun!: any;

  //right status
  salary!: any;
  noDiplom!: any;
  autoEmploi!: any;
  autreRightStatus!: any;

  //hight diplome
  cfee!: any;
  bfem!: any;
  cap_bepHightDip!: any;
  bacHightDip!: any;
  bts_dut_deugHightDip!: any;
  licence3HightDip!: any;
  master1HightDip!: any;
  master2HightDip!: any;
  doctoratHightDip!: any;

  //Bac (Serie)
  lSerie!: any;
  autreSerie!: any;
  tSerie!: any;
  fSerie!: any;
  gTegSerie!: any;
  sSerie!: any;

  //decsipline dut bts
  infoTelecom!: any;
  autredesci!: any;
  gestion!: any;
  scienceInfoCommunication!: any;
  sante!: any;
  mathStatDutBts!: any;
  environementDutBts!: any;
  scienceGenieDutBts!: any;
  physicChemieDutBts!: any;
  architechDutBts!: any;
  droitDutBts!: any;
  educationDutBts!: any;
  philoSocio_DutBts!: any;
  histoireGesoDutBts!: any;
  langueLiterDutBts!: any;

  //descipline licence, master
  infoTelecomLicMaster!: any;
  autreLicMaster!: any;
  gestionLicMaster!: any;
  langueLicMaster!: any;
  droitScienceMaster!: any;
  mathStatLicMaster!: any;
  environemenLicMaster!: any;
  scienceGenieLicMaster!: any;
  physicChemieLicMaster!: any;
  architechLicMaster!: any;
  droitLicMaster!: any;
  educationLicMaster!: any;
  philoSocio_LicMaster!: any;
  histoireGeoLicMaster!: any;
  langueLiterLicMaster!: any;
  santeLicMaster!: any;

  //disponibility
  tresLimite!: any;
  limite!: any;
  moyDispo!: any;
  disponible!: any;
  tresDisponible!: any;

  //region
  Dakar!: any;
  Diourbel!: any;
  Fatick!: any;
  Kaffrine!: any;
  Kaolack!: any;
  Kédougou!: any;
  Kolda!: any;
  Louga!: any;
  Matam!: any;
  SaintLuis!: any;
  Sedhiou!: any;
  Tambacounda!: any;
  Thies!: any;
  Ziguinchor!: any;
  Etranger!: any;

  // Variables pour les labels, données et pourcentages
  chartLabels: string[] = [];
  chartData: number[] = [];
  chartPercentages: number[] = [];

  cohorte: any = null;

  breadcrumbItems!: BreadcrumbItem[];
  infoparcours: any;

  constructor(
    private spinnerService: SpinnerServiceService,
    private router: Router,
    private serviceAppel: AppelsService,
    private formBuilder: FormBuilder
  ) {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  ngAfterViewInit(): void {
    // this.printAllStatistics(this.recuCohorte);
  }
  ngOnDestroy(): void { }
  ngOnInit(): void {
    this.loadJotformScript();
    this.cohorte = sessionStorage.getItem('cohorte');

    this.printAllStatistics(this.cohorte);

    this.serviceAppel.allCohorte().subscribe({
      next: (cohortes) => {
        this.listeCohortes = cohortes?.object;
        //console.log("Liste cohorte unique", this.listeCohortes);
      },
    });
    this.initForm();

    this.breadcrumbItems = [
      { label: 'SIGUI' },
      {
        label: `SESSION ${this.cohorte}`,
        url: `/dashboard/appels/candidatures/${this.cohorte}`,
      },
      {
        label: 'CANDIDATURES',
        url: `/dashboard/appels/candidatures/${this.cohorte}`,
      },
    ];
  }

  onClick(): void {
    this.router.navigateByUrl('/');
  }

  //Chargement de iFrme
  loadJotformScript() {
    const doc = window.document;
    const scripts = doc.getElementsByTagName('script')[0];
    if (!doc.getElementById('jotform-async')) {
      const script = doc.createElement('script');
      script.async = true;
      script.id = 'jotform-async';
      script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-report-embed.js';
      scripts?.parentNode?.insertBefore(script, scripts);

      this.spinnerService.hideSpinner();
    }
  }

  nextPage() {
    if (this.currentPage < 17) {
      this.currentPage++;
    }
    //creer les charts
    this.printAllStatistics(this.cohorte);
    // this.setPage(button.id)
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
    //creer les charts
    this.printAllStatistics(this.cohorte);
  }

  //ini
  initForm() {
    this.formGroup = this.formBuilder.group({
      cohorte: ['', Validators.required],
    });
  }

  onSubmit() {
    //console.log("form",this.formGroup.value)
    if (this.formGroup.valid) {
      this.recuCohorte = this.formGroup.get('cohorte')?.value;
      //console.log("cohorte saisie",this.recuCohorte)
      this.printAllStatistics(this.recuCohorte);
    } else {
      this.showActiveModal = true;
    }
  }

  printAllStatistics(cohorte: string) {
    if (cohorte != null) {
      // SIG2405-FODE
      this.spinnerService.showSpinner();
      this.serviceAppel.allStaticsDiagrams(cohorte).subscribe({
        next: (stats) => {
          //console.log("all",stats)

          this.tableExportOfStats = stats?.object;
          /*             console.log("a imprimer ", stats?.object)
           */
          //gender
          this.homme = stats?.object.maleCount;
          this.femme = stats?.object.femaleCount;

          //nationality
          this.senegal = stats?.object.nationalCount;
          this.autre = stats?.object.foreignCount;

          //status char
          this.dimplomeWithoutEmployedCount =
            stats?.object.dimplomeWithoutEmployedCount;
          this.autreStatus = stats?.object.autreStatus;
          this.studentCount = stats?.object.studentCount;
          //console.log("dip, autr, student :",this.dimplomeWithoutEmployedCount ,this.autre, this.studentCount);

          //level
          this.licence1Level = stats?.object.licence1Level;
          this.licence2Level = stats?.object.licence2Level;
          this.licence3Level = stats?.object.licence3Level;
          this.master1Level = stats?.object.master1Level;
          this.master2Level = stats?.object.master2Level;
          this.doctorantLevel = stats?.object.doctorantLevel;
          this.autreLevel = stats?.object.autreLevel;

          //riht handicap 11
          this.handicaps_visuel = stats?.object.handicaps_visuel;
          this.handicaps_auditif = stats?.object.handicaps_auditif;
          this.handicaps_moteur = stats?.object.handicaps_moteur;
          this.handicaps_autre = stats?.object.handicaps_autre;

          //family
          this.DevLogi = stats?.object.devLogi;
          this.eBusiness = stats?.object.ebusiness;
          this.techEmergentCys = stats?.object.techEmergentCys;
          this.IntelligenceArtiData = stats?.object.intelligenceArtiData;
          this.cca = stats?.object.creationContenu;
          // //console.log("DEV :",this.DevLogi, " eBussiness :",this.eBusiness," Tech  :",this.techEmergentCys," IA :",this.IntelligenceArtiData);

          // console.log('ccaaa ', this.cca)
          //forceN know
          this.reseau = stats?.object.reseau;
          this.siteWeb = stats?.object.siteWeb;
          this.boucheOreille = stats?.object.boucheOreille;
          this.TvRadio = stats?.object.TvRadio;
          this.presse = stats?.object.presse;
          this.siteWebpartenaire = stats?.object.siteWebpartenaire;
          this.autreKnow = stats?.object.autreKnow;

          //FirceN certified
          this.certified = stats?.object.certified;
          this.noCertified = stats?.object.noCertified;

          //projet issu
          this.poursuivreEtude = stats?.object.poursuivreEtude;
          this.lancerEntreprise = stats?.object.lancerEntreprise;
          this.chercheEmploi = stats?.object.chercheEmploi;
          this.retourEntreprise = stats?.object.retourEntreprise;
          this.aucun = stats?.object.aucun;

          //right status
          this.salary = stats?.object.salary;
          this.noDiplom = stats?.object.noDiplom;
          this.autoEmploi = stats?.object.autoEmploi;
          this.autreRightStatus = stats?.object.autreRightStatus;

          //hight diplome
          this.cfee = stats?.object.cfee;
          this.bfem = stats?.object.bfem;
          this.cap_bepHightDip = stats?.object.cap_bepHightDip;
          this.bacHightDip = stats?.object.bacHightDip;
          this.bts_dut_deugHightDip = stats?.object.bts_dut_deugHightDip;
          this.licence3HightDip = stats?.object.licence3HightDip;
          this.master1HightDip = stats?.object.master1HightDip;
          this.master2HightDip = stats?.object.master2HightDip;
          this.doctoratHightDip = stats?.object.doctoratHightDip;

          //serie bac
          this.lSerie = stats?.object.lserie;
          this.autreSerie = stats?.object.autreSerie;
          this.tSerie = stats?.object.tserie;
          this.fSerie = stats?.object.fserie;
          this.gTegSerie = stats?.object.gtegSerie;
          this.sSerie = stats?.object.sserie;

          //descipline bts, dut
          this.infoTelecom = stats?.object.infoTelecom;
          this.autredesci = stats?.object.autredesci;
          this.gestion = stats?.object.gestion;
          this.scienceInfoCommunication =
            stats?.object.scienceInfoCommunication;
          this.sante = stats?.object.sante;
          this.mathStatDutBts = stats?.object.mathStatDutBts;
          this.environementDutBts = stats?.object.environementDutBts;
          this.scienceGenieDutBts = stats?.object.scienceGenieDutBts;
          this.physicChemieDutBts = stats?.object.physicChemieDutBts;
          this.architechDutBts = stats?.object.architechDutBts;
          this.droitDutBts = stats?.object.droitDutBts;
          this.educationDutBts = stats?.object.educationDutBts;
          this.philoSocio_DutBts = stats?.object.philoSocio_DutBts;
          this.histoireGesoDutBts = stats?.object.histoireGesoDutBts;
          this.langueLiterDutBts = stats?.object.langueLiterDutBts;

          //licence master
          this.infoTelecomLicMaster = stats?.object.infoTelecomLicMaster;
          this.autreLicMaster = stats?.object.autreLicMaster;
          this.gestionLicMaster = stats?.object.gestionLicMaster;
          this.langueLicMaster = stats?.object.langueLicMaster;
          this.droitScienceMaster = stats?.object.droitScienceMaster;
          this.mathStatLicMaster = stats?.object.mathStatLicMaster;
          this.environemenLicMaster = stats?.object.environemenLicMaster;
          this.scienceGenieLicMaster = stats?.object.scienceGenieLicMaster;
          this.physicChemieLicMaster = stats?.object.physicChemieLicMaster;
          this.architechLicMaster = stats?.object.architechLicMaster;
          this.droitLicMaster = stats?.object.droitLicMaster;
          this.educationLicMaster = stats?.object.educationLicMaster;
          this.philoSocio_LicMaster = stats?.object.philoSocio_LicMaster;
          this.histoireGeoLicMaster = stats?.object.histoireGeoLicMaster;
          this.santeLicMaster = stats?.object.santeLicMaster;

          //disponibility
          this.tresLimite = stats?.object.tresLimite;
          this.limite = stats?.object.limite;
          this.moyDispo = stats?.object.moyDispo;
          this.disponible = stats?.object.disponible;
          this.tresDisponible = stats?.object.tresDisponible;

          //region
          this.Dakar = stats?.object.dakar;
          this.Diourbel = stats?.object.diourbel;
          this.Fatick = stats?.object.fatick;
          this.Kaffrine = stats?.object.kaffrine;
          this.Kaolack = stats?.object.kaolack;
          this.Kédougou = stats?.object.kédougou;
          this.Kolda = stats?.object.kolda;
          this.Louga = stats?.object.louga;
          this.Matam = stats?.object.matam;
          this.SaintLuis = stats?.object.saintLuis;
          this.Sedhiou = stats?.object.sedhiou;
          this.Tambacounda = stats?.object.tambacounda;
          this.Thies = stats?.object.thies;
          this.Ziguinchor = stats?.object.ziguinchor;
          this.Etranger = stats?.object.etranger;

          //pour exporter les diagrams
          this.tableExportOfStats = [
            { name: 'Nombre des hommes', value: this.homme },
            { name: 'Nombre des femmes', value: this.femme },
            { name: 'Nationalité Sénégalaise', value: this.senegal },
            { name: 'Etranger', value: this.autre },
            {
              name: 'Diplômé/Sans emploi',
              value: this.dimplomeWithoutEmployedCount,
            },
            { name: 'Autre Statut', value: this.autreStatus },
            { name: 'Statut Étudiant', value: this.studentCount },

            { name: 'Niveau licence 1', value: this.licence1Level },
            { name: 'Niveau licence 2', value: this.licence2Level },
            { name: 'Niveau licence 3', value: this.licence3Level },
            { name: 'Niveau master 1', value: this.master1Level },
            { name: 'Niveau master 2', value: this.master2Level },
            { name: 'Niveau doctorant', value: this.doctorantLevel },
            { name: 'Autre Niveau', value: this.autreLevel },

            {
              name: 'Nombre des handicaps Visuels',
              value: this.handicaps_visuel,
            },
            {
              name: 'Nombre des handicaps Auditifs',
              value: this.handicaps_auditif,
            },
            {
              name: 'Nombre des handicaps Moteurs',
              value: this.handicaps_moteur,
            },
            {
              name: 'Nombre des autres Handicaps',
              value: this.handicaps_autre,
            },

            { name: 'Développement Logiciel', value: this.DevLogi },
            { name: 'eBusiness', value: this.eBusiness },
            { name: 'Technologies Emergentes', value: this.techEmergentCys },
            {
              name: 'Intelligence Artificielle et Data',
              value: this.IntelligenceArtiData,
            },
            {
              name: 'CRÉATION DE CONTENU AUDIOVISUELS ANIMES',
              value: this.cca,
            },

            { name: 'Réseau', value: this.reseau },
            { name: 'Site Web', value: this.siteWeb },
            { name: 'Bouche à Oreille', value: this.boucheOreille },
            { name: 'TV/Radio', value: this.TvRadio },
            { name: 'Presse', value: this.presse },
            { name: 'Site Web Partenaire', value: this.siteWebpartenaire },
            { name: 'Autre Connaissance', value: this.autreKnow },

            { name: 'Certifié', value: this.certified },
            { name: 'Non Certifié', value: this.noCertified },

            { name: 'Poursuivre les Etudes', value: this.poursuivreEtude },
            { name: 'Lancer une Entreprise', value: this.lancerEntreprise },
            { name: 'Chercher un Emploi', value: this.chercheEmploi },
            { name: 'Retourner en Entreprise', value: this.retourEntreprise },
            { name: 'Aucun Projet', value: this.aucun },

            { name: 'Salarié', value: this.salary },
            { name: 'Sans Diplôme', value: this.noDiplom },
            { name: 'Auto Emploi', value: this.autoEmploi },
            { name: 'Autre Statut de Droit', value: this.autreRightStatus },

            { name: 'CFEE', value: this.cfee },
            { name: 'BFEM', value: this.bfem },
            { name: 'CAP/BEP', value: this.cap_bepHightDip },
            { name: 'Bac', value: this.bacHightDip },
            { name: 'BTS/DUT/DEUG', value: this.bts_dut_deugHightDip },
            { name: 'Licence 3', value: this.licence3HightDip },
            { name: 'Master 1', value: this.master1HightDip },
            { name: 'Master 2', value: this.master2HightDip },
            { name: 'Doctorat', value: this.doctoratHightDip },

            { name: 'L Série', value: this.lSerie },
            { name: 'Autre Série', value: this.autreSerie },
            { name: 'T Série', value: this.tSerie },
            { name: 'F Série', value: this.fSerie },
            { name: 'G Série', value: this.gTegSerie },
            { name: 'S Série', value: this.sSerie },

            {
              name: 'Informatique et Télécommunications',
              value: this.infoTelecom,
            },
            { name: 'Autre Discipline', value: this.autredesci },
            { name: 'Gestion', value: this.gestion },
            {
              name: "Sciences de l'Information et de la Communication",
              value: this.scienceInfoCommunication,
            },
            { name: 'Santé', value: this.sante },
            {
              name: 'Mathématiques et Statistiques',
              value: this.mathStatDutBts,
            },
            { name: 'Environnement', value: this.environementDutBts },
            { name: "Sciences de l'Ingénieur", value: this.scienceGenieDutBts },
            { name: 'Physique et Chimie', value: this.physicChemieDutBts },
            { name: 'Architecture', value: this.architechDutBts },
            { name: 'Droit', value: this.droitDutBts },
            { name: 'Éducation', value: this.educationDutBts },
            {
              name: 'Philosophie et Sociologie',
              value: this.philoSocio_DutBts,
            },
            { name: 'Histoire et Géographie', value: this.histoireGesoDutBts },
            { name: 'Langues et Littérature', value: this.langueLiterDutBts },

            {
              name: 'Informatique et Télécommunications (Licence/Master)',
              value: this.infoTelecomLicMaster,
            },
            {
              name: 'Autre Discipline (Licence/Master)',
              value: this.autreLicMaster,
            },
            { name: 'Gestion (Licence/Master)', value: this.gestionLicMaster },
            { name: 'Langues (Licence/Master)', value: this.langueLicMaster },
            {
              name: 'Droit et Sciences Politiques (Master)',
              value: this.droitScienceMaster,
            },
            {
              name: 'Mathématiques et Statistiques (Licence/Master)',
              value: this.mathStatLicMaster,
            },
            {
              name: 'Environnement (Licence/Master)',
              value: this.environemenLicMaster,
            },
            {
              name: "Sciences de l'Ingénieur (Licence/Master)",
              value: this.scienceGenieLicMaster,
            },
            {
              name: 'Physique et Chimie (Licence/Master)',
              value: this.physicChemieLicMaster,
            },
            {
              name: 'Architecture (Licence/Master)',
              value: this.architechLicMaster,
            },
            { name: 'Droit (Licence/Master)', value: this.droitLicMaster },
            {
              name: 'Éducation (Licence/Master)',
              value: this.educationLicMaster,
            },
            {
              name: 'Philosophie et Sociologie (Licence/Master)',
              value: this.philoSocio_LicMaster,
            },
            {
              name: 'Histoire et Géographie (Licence/Master)',
              value: this.histoireGeoLicMaster,
            },
            { name: 'Santé (Licence/Master)', value: this.santeLicMaster },

            { name: 'Très Limité', value: this.tresLimite },
            { name: 'Limité', value: this.limite },
            { name: 'Moyennement Disponible', value: this.moyDispo },
            { name: 'Disponible', value: this.disponible },
            { name: 'Très Disponible', value: this.tresDisponible },

            { name: 'Dakar', value: this.Dakar },
            { name: 'Diourbel', value: this.Diourbel },
            { name: 'Fatick', value: this.Fatick },
            { name: 'Kaffrine', value: this.Kaffrine },
            { name: 'Kaolack', value: this.Kaolack },
            { name: 'Kédougou', value: this.Kédougou },
            { name: 'Kolda', value: this.Kolda },
            { name: 'Louga', value: this.Louga },
            { name: 'Matam', value: this.Matam },
            { name: 'Saint-Louis', value: this.SaintLuis },
            { name: 'Sédhiou', value: this.Sedhiou },
            { name: 'Tambacounda', value: this.Tambacounda },
            { name: 'Thiès', value: this.Thies },
            { name: 'Ziguinchor', value: this.Ziguinchor },
            { name: 'Étranger', value: this.Etranger },
          ];

          this.spinnerService.showSpinner();
          //creer les charts
          this.updateCharts();

          this.spinnerService.hideSpinner();

          //right status bar vertical
          this.initializeChartStatusVertical();
        },
        error: (err) => {
          alert('Erreur de Recuperation des Données');
        },
      });
    } else {
      this.showActiveModal = true;
    }
  }

  updateCharts() {
    this.destroyCharts();

    if (this.canvasGender && this.canvasGender.nativeElement) {
      this.chartGender = this.createChartPie(
        this.canvasGender.nativeElement,
        'Répartition des candidats par genre',
        ['Hommes', 'Femmes'],
        [this.homme, this.femme],
        ['rgb(14, 159, 110)', 'rgb(240, 82, 82)']
      );
    }
    if (this.canvasNationality && this.canvasNationality.nativeElement) {
      this.chartNationality = this.createChartPie(
        this.canvasNationality.nativeElement,
        'Répartition des candidats par nationalité',
        ['Sénégalaise', 'Autres'],
        [this.senegal, this.autre],
        ['rgb(14, 159, 110)', 'rgb(240, 82, 82)']
      );
    }
    //status bar horizonetal
    if (this.canvasStatus && this.canvasStatus.nativeElement) {
      this.chartStatus = this.createChartPie(
        this.canvasStatus.nativeElement,
        'Répartition des candidats par statut',
        [
          'Diplômé/Sans emploi',
          'Autre (Salarié, non-diplômé, auto-emploi...)',
          'Étudiant',
        ],
        [
          this.dimplomeWithoutEmployedCount,
          this.autreStatus,
          this.studentCount,
        ],
        ['rgb(14, 159, 110)', 'rgb(240, 82, 82)', 'rgb(115, 147, 179)']
      );
    }

    //status bar vertical
    if (this.canvasStatusVertical && this.canvasStatusVertical.nativeElement) {
      this.chartStatus = this.createChartBarVertical(
        this.canvasStatusVertical.nativeElement,
        'Répartition des candidats selon le statut',
        [
          'Diplômé/Sans emploi',
          'Autre (Salarié, non-diplômé, auto-emploi...)',
          'Étudiant',
        ],
        [
          this.dimplomeWithoutEmployedCount,
          this.autreStatus,
          this.studentCount,
        ],
        ['rgb(14, 159, 110)', 'rgb(240, 82, 82)', 'rgb(115, 147, 179)']
      );
    }

    //level
    if (this.canvasLevel && this.canvasLevel.nativeElement) {
      this.chartLevel = this.createChartBar(
        this.canvasLevel.nativeElement,
        "Répartition des candidats selon niveau d'étude ",
        [
          'licence 1',
          'licence 2',
          'licence 3',
          'master 1',
          'master 2',
          'doctorat',
          'autres',
        ],
        [
          this.licence1Level,
          this.licence2Level,
          this.licence3Level,
          this.master1Level,
          this.master2Level,
          this.doctorantLevel,
          this.autreLevel,
        ],
        [
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(153, 102, 255, 0.2)',
        ]
      );
    }

    //right handicap
    if (this.canvasRightHandicap && this.canvasRightHandicap.nativeElement) {
      this.chartRightStatus = this.createChartPie(
        this.canvasRightHandicap.nativeElement,
        'Répartition des candidats par autre handicap',
        ['malvoyant ', 'Malentendant', 'Handicap moteur', 'Autre handicap'],
        [
          this.handicaps_visuel,
          this.handicaps_auditif,
          this.handicaps_moteur,
          this.handicaps_autre,
        ],
        [
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(201, 203, 207, 0.2)',
        ]
      );
    }

    //family
    if (this.canvasFamily && this.canvasFamily.nativeElement) {
      this.chartFamily = this.createChartPie(
        this.canvasFamily.nativeElement,
        'Répartition des candidats par autre famille',
        [
          'DÉVELOPPEMENT LOGICIEL ',
          'e-BUSINESS',
          'TECHNOLOGIES EMERGENTES ET CYBERSECURITE',
          'INTELLIGENCE ARTIFICIELLE ET DATA',
          'CRÉATION DE CONTENU AUDIOVISUELS ANIMES',
        ],
        [
          this.DevLogi,
          this.eBusiness,
          this.techEmergentCys,
          this.IntelligenceArtiData,
          this.cca,
        ],
        [
          'rgb(198, 169, 254)',
          'rgb(227, 161, 227)',
          'rgb(252, 162, 162)',
          'rgb(255, 193, 79)',
        ]
      );
    }

    //forceN know
    if (this.canvasForceNKnow && this.canvasForceNKnow.nativeElement) {
      this.chartFamily = this.createChartPie(
        this.canvasForceNKnow.nativeElement,
        'Répartition des candidats par  connaissance',
        [
          'Sur les réseaux ',
          'Site web UNCHK',
          'Bouche à oreille',
          'TV - Radio',
          'Presse écrite',
          'Site web partenaires',
          'Autres',
        ],
        [
          this.reseau,
          this.siteWeb,
          this.boucheOreille,
          this.TvRadio,
          this.presse,
          this.siteWebpartenaire,
          this.autreKnow,
        ],
        [
          'rgb(198, 169, 254',
          'rgba(153, 102, 255, 0.2)',
          'rgb(227, 161, 227)',
          'rgb(255, 193, 79)',
          'rgb(204, 204, 204)',
          'rgb(145, 217, 173)',
          'rgb(252, 162, 162)',
        ]
      );
    }

    //fcertified
    if (this.canvasCertified && this.canvasCertified.nativeElement) {
      this.chartCertified = this.createChartBar(
        this.canvasCertified.nativeElement,
        'Répartition des candidats certifiés',
        ['Oui', 'Non'],
        [this.certified, this.noCertified],
        ['rgb(198, 169, 254)', 'rgb(227, 161, 227)']
      );
    }

    //projet issu
    if (this.canvasProjetIssu && this.canvasProjetIssu.nativeElement) {
      this.chartProjet = this.createChartPie(
        this.canvasProjetIssu.nativeElement,
        'Répartition des candidats par projet issu',
        [
          'Poursuivre mes études',
          'Lancer mon entreprise',
          'Chercher un emploi',
          'Retourner dans mon entreprise',
          'Aucun de ces projets',
        ],
        [
          this.poursuivreEtude,
          this.lancerEntreprise,
          this.chercheEmploi,
          this.retourEntreprise,
          this.aucun,
        ],
        [
          'rgb(252, 162, 162)',
          'rgb(227, 161, 227)',
          'rgb(198, 169, 254)',
          'rgb(145, 217, 173)',
          'rgb(255, 193, 79)',
        ]
      );
    }

    //right status
    if (this.canvasRightStatus && this.canvasRightStatus.nativeElement) {
      this.chartProjet = this.createChartBar(
        this.canvasRightStatus.nativeElement,
        'Répartition des candidats par aute statut',
        [
          'Poursuivre mes études',
          'Lancer mon entreprise',
          'Chercher un emploi',
          'Retourner dans mon entreprise',
          'Aucun de ces projets',
        ],
        [this.salary, this.noDiplom, this.autoEmploi, this.autreRightStatus],
        [
          'rgb(198, 169, 254)',
          'rgb(227, 161, 227)',
          'rgb(252, 162, 162)',
          'rgb(255, 193, 79)',
        ]
      );
    }

    //hight diplome
    if (this.canvasHightDiplome && this.canvasHightDiplome.nativeElement) {
      this.chartHightDiplome = this.createChartBar(
        this.canvasHightDiplome.nativeElement,
        'Répartition des candidats par le plus haut diplome',
        [
          'CFEE',
          'BFM',
          'CAP',
          'AP/BEP',
          'Baccalauréat',
          'BTS/DUT/DEUG',
          'Licence ( Bac+3)',
          'Master 1',
          'Master 2',
          'Doctorat',
        ],
        [
          this.cfee,
          this.bfem,
          this.cap_bepHightDip,
          this.bacHightDip,
          this.bts_dut_deugHightDip,
          this.licence3HightDip,
          this.master1HightDip,
          this.master2HightDip,
          this.doctoratHightDip,
        ],
        [
          'rgb(198, 169, 254',
          'rgb(255, 193, 79)',
          'rgb(227, 161, 227)',
          'rgb(204, 204, 204)',
          'rgb(145, 217, 173)',
          'rgb(252, 162, 162)',
          'rgb(145, 217, 173)',
          'rgba(201, 203, 207, 0.2)',
          'rgba(153, 102, 255, 0.2)',
        ]
      );
    }

    //bac
    if (this.canvasSeriebac && this.canvasSeriebac.nativeElement) {
      this.chartBacSerie = this.createChartBar(
        this.canvasSeriebac.nativeElement,
        'Répartition des candidats par le serie 12',
        ['L', 'Autre', 'T', 'F', 'G-STEG', 'S'],
        [
          this.lSerie,
          this.autreSerie,
          this.tSerie,
          this.fSerie,
          this.gTegSerie,
          this.sSerie,
        ],
        [
          'rgb(198, 169, 254',
          'rgb(255, 193, 79)',
          'rgb(227, 161, 227)',
          'rgb(204, 204, 204)',
          'rgb(145, 217, 173)',
          'rgb(252, 162, 162)',
        ]
      );
    }

    //Descipline dut, bts
    if (this.canvasDesciDutBts && this.canvasDesciDutBts.nativeElement) {
      this.chartDesciDutBts = this.createChartBar(
        this.canvasDesciDutBts.nativeElement,
        'Répartition des candidats par descipline',
        [
          'Informatique / Télécommunications',
          'Autres',
          'Gestion (commerce, marketing, ressources humaines, etc.) / Économie / Administration',
          'Sciences de l’information et de la communication',
          'Santé (médecine, pharmacie, etc.) / Social',
          'Mathématiques / Statistiques',
          'Environnement / Géologie / Sciences de la vie (biologie, etc.)',
          'Sciences du génie',
          'Physique / Chimie',
          'Architecture Arts / Design / Culture',
          'Droit / Science politique',
          'Éducation',
          'Philosophie / Sociologie / Anthropologie / Psychologie',
          'Histoire / Géographie',
          'Langues / Littérature / Lettres',
        ],
        [
          this.infoTelecom,
          this.autredesci,
          this.gestion,
          this.scienceInfoCommunication,
          this.sante,
          this.mathStatDutBts,
          this.environementDutBts,
          this.scienceGenieDutBts,
          this.physicChemieDutBts,
          this.architechDutBts,
          this.droitDutBts,
          this.educationDutBts,
          this.philoSocio_DutBts,
          this.histoireGesoDutBts,
          this.langueLiterDutBts,
        ],
        [
          'rgb(198, 169, 254',
          'rgb(255, 193, 79)',
          'rgb(227, 161, 227)',
          'rgb(204, 204, 204)',
          'rgb(252, 162, 162)',
          'rgb(145, 217, 173)',
          'rgba(201,203,207,0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgb(14, 159, 110)',
          'rgb(240, 82, 82)',
          'rgb(204, 204, 204)',
          'rgb(84, 41, 32)',
        ]
      );
    }

    //Descipline master, licence
    if (
      this.canvasDesciLicenceMaster &&
      this.canvasDesciLicenceMaster.nativeElement
    ) {
      this.chartDesciMasterLicence = this.createChartBar(
        this.canvasDesciLicenceMaster.nativeElement,
        'Répartition des candidats par descipline (Licence, Master)',
        [
          'Informatique / Télécommunications',
          'Autres',
          'Gestion (commerce, marketing, ressources humaines, etc.) / Économie / Administration',
          'Sciences de l’information et de la communication',
          'Santé (médecine, pharmacie, etc.) / Social',
          'Mathématiques / Statistiques',
          'Environnement / Géologie / Sciences de la vie (biologie, etc.)',
          'Sciences du génie',
          'Physique / Chimie',
          'Architecture Arts / Design / Culture',
          'Droit / Science politique',
          'Éducation',
          'Philosophie / Sociologie / Anthropologie / Psychologie',
          'Histoire / Géographie',
          'Langues / Littérature / Lettres',
        ],
        [
          this.autreLicMaster,
          this.gestionLicMaster,
          this.langueLicMaster,
          this.droitScienceMaster,
          this.mathStatLicMaster,
          this.environemenLicMaster,
          this.scienceGenieLicMaster,
          this.physicChemieLicMaster,
          this.architechLicMaster,
          this.droitLicMaster,
          this.educationLicMaster,
          this.philoSocio_LicMaster,
          this.histoireGeoLicMaster,
          this.santeLicMaster,
        ],
        [
          'rgb(198, 169, 254',
          'rgb(255, 193, 79)',
          'rgb(227, 161, 227)',
          'rgb(204, 204, 204)',
          'rgb(252, 162, 162)',
          'rgb(145, 217, 173)',
          'rgba(201,203,207,0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgb(14, 159, 110)',
          'rgb(240, 82, 82)',
          'rgb(204, 204, 204)',
          'rgb(84, 41, 32)',
        ]
      );
    }

    //Disponiblity
    if (this.canvasDisponible && this.canvasDisponible.nativeElement) {
      this.chartDisponible = this.createChartBar(
        this.canvasDisponible.nativeElement,
        'Répartition des candidats selon la disponiblité',
        [
          'Très limitée (moins de 1h par jour)',
          'Limitée (entre 1 et 2h par jour)',
          'Moyennement disponible (entre 2 et 3h par jour)',
          'Disponible (entre 3 et 4h par jour)',
          'Très disponible (plus de 4h par jour)',
        ],
        [
          this.tresLimite,
          this.limite,
          this.moyDispo,
          this.disponible,
          this.tresDisponible,
        ],
        [
          'rgb(198, 169, 254',
          'rgb(255, 193, 79)',
          'rgb(227, 161, 227)',
          'rgb(204, 204, 204)',
          'rgb(252, 162, 162)',
        ]
      );
    }

    //Region
    if (this.canvasRegion && this.canvasRegion.nativeElement) {
      this.chartRegion = this.createChartBar(
        this.canvasRegion.nativeElement,
        'Répartition des candidats par region',
        [
          'Dakar',
          'Diourbel',
          'Fatick',
          'Kaffrine',
          'Kaolack',
          'Kédougou',
          'Kolda',
          'Louga',
          'Matam',
          'SaintLuis',
          'Sedhiou',
          'Tambacounda',
          'Thies',
          'Ziguinchor',
          'Etranger',
        ],
        [
          this.Dakar,
          this.Diourbel,
          this.Fatick,
          this.Kaffrine,
          this.Kaolack,
          this.Kédougou,
          this.Kolda,
          this.Louga,
          this.Matam,
          this.SaintLuis,
          this.Sedhiou,
          this.Tambacounda,
          this.Thies,
          this.Ziguinchor,
          this.Etranger,
        ],
        [
          'rgb(198, 169, 254',
          'rgb(255, 193, 79)',
          'rgb(227, 161, 227)',
          'rgb(204, 204, 204)',
          'rgb(252, 162, 162)',
          'rgb(145, 217, 173)',
          'rgba(201,203,207,0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgb(14, 159, 110)',
          'rgb(240, 82, 82)',
          'rgb(204, 204, 204)',
          'rgb(84, 41, 32)',
        ]
      );
    }
  }

  //diagram pie
  createChartPie(
    canvas: HTMLCanvasElement,
    title: string,
    labels: string[],
    data: number[],
    backgroundColors: string[]
  ) {
    const ctx = canvas.getContext('2d');
    if (ctx) {
      return new Chart(ctx, {
        type: 'pie',
        data: {
          labels,
          datasets: [
            {
              data,
              backgroundColor: backgroundColors,
              hoverOffset: 4,
            },
          ],
        },
        options: {
          // scales: {
          //   y: {
          //     ticks: {
          //       crossAlign: 'far',
          //     }
          //   }
          // },
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
        },
      });
    }
    return null;
  }

  //diagram bar horizonetal
  createChartBar(
    canvas: HTMLCanvasElement,
    title: string,
    labels: string[],
    data: number[],
    backgroundColors: string[]
  ) {
    const ctx = canvas.getContext('2d');
    if (ctx) {
      return new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              data,
              backgroundColor: backgroundColors,
            },
          ],
        },
        options: {
          indexAxis: 'y',
          // scales: {
          //   y: {
          //     beginAtZero: true
          //   }
          // },
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
        },
      });
    }
    return null;
  }

  //diagram vertical
  createChartBarVertical(
    canvas: HTMLCanvasElement,
    title: string,
    labels: string[],
    data: number[],
    backgroundColors: string[]
  ) {
    const ctx = canvas.getContext('2d');

    if (ctx) {
      return new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: title,
              data,
              borderWidth: 1,
              backgroundColor: backgroundColors,
            },
          ],
        },
        options: {
          // scales: {
          //   y: {
          //     beginAtZero: true
          //   }
          // },
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
        },
      });
    }
    return null;
  }

  destroyCharts() {
    if (this.chartGender) {
      this.chartGender.destroy();
    }
    if (this.chartNationality) {
      this.chartNationality.destroy();
    }
    if (this.chartStatus) {
      this.chartStatus.destroy();
    }

    if (this.chartLevel) {
      this.chartLevel.destroy();
    }

    if (this.chartRightStatus) {
      this.chartRightStatus.destroy();
    }

    if (this.chartFamily) {
      this.chartFamily.destroy();
    }

    if (this.chartKnow) {
      this.chartKnow.destroy();
    }

    if (this.chartCertified) {
      this.chartCertified.destroy();
    }

    if (this.chartProjet) {
      this.chartProjet.destroy();
    }

    if (this.chartHightDiplome) {
      this.chartHightDiplome.destroy();
    }

    if (this.chartBacSerie) {
      this.chartBacSerie.destroy();
    }

    if (this.chartDesciDutBts) {
      this.chartDesciDutBts.destroy();
    }

    if (this.chartDesciMasterLicence) {
      this.chartDesciMasterLicence.destroy();
    }

    if (this.chartDisponible) {
      this.chartDisponible.destroy();
    }

    if (this.chartRegion) {
      this.chartRegion.destroy();
    }
  }

  calculatePercentages(data: number[]): any[] {
    const total = data.reduce((sum, value) => sum + value, 0);
    return data.map((value) => ((value / total) * 100).toFixed(2));
  }

  // Fonction d'init du graphique vertical
  initializeChartStatusVertical() {
    if (this.canvasStatusVertical && this.canvasStatusVertical.nativeElement) {
      this.chartLabels = [
        'Diplômé/Sans emploi',
        'Autre (Salarié, non-diplômé, auto-emploi...)',
        'Étudiant',
      ];
      this.chartData = [
        this.dimplomeWithoutEmployedCount,
        this.autreStatus,
        this.studentCount,
      ];
      this.chartPercentages = this.calculatePercentages(this.chartData);

      this.chartStatusVertical = this.createChartBarVertical(
        this.canvasStatusVertical.nativeElement,
        'Répartition des candidats par statut',
        this.chartLabels,
        this.chartData,
        ['rgb(14, 159, 110)', 'rgb(240, 82, 82)', 'rgb(115, 147, 179)']
      );
    }
  }

  onCheckedChange(event: any) {
    if (event.target.checked) {
      this.showActiveModal = true;
    } else {
      this.showDesactiveModal = true;
    }
  }

  closeActiveModal() {
    this.showActiveModal = false;
    this.active = false;
  }

  exportTableOfStats() {
    TableUtil.exportArrayToExcel(this.tableExportOfStats, 'Statistics');
    //console.log("a imprimer 2 ", this.tableExportOfStats)
  }

  currentButton = 1;
  totalButtons = 17;
  buttonsPerPage = 6;

  //indicateurs
  setPage(page: number) {
    this.currentPage = page;
    this.printAllStatistics(this.cohorte);
  }

  get paginatedButtons() {
    const start = (this.currentButton - 1) * this.buttonsPerPage;
    return this.buttons.slice(start, start + this.buttonsPerPage);
  }

  buttons = [
    { id: 1, label: 'Genre | Nationalité' },
    // { id: 2, label: 'Nationalité' },
    // { id: 3, label: 'Statut' },
    { id: 2, label: 'Status' },
    { id: 3, label: 'Level' },
    /*   { id: 5, label: 'Autre status' },
  { id: 6, label: 'Handicap | Famille' }, */
    // { id: 8, label: 'Famille' },
    /* { id: 7, label: 'Connaissance | Projet issu' }, */
    { id: 4, label: 'Certifié' },
    // { id: 11, label: 'Projet issu' },
    { id: 5, label: 'Haut Diplôme' },
    /* { id: 10, label: 'Séries' },
  { id: 11, label: 'Discipline' },
  { id: 12, label: 'Licence, Master' },*/
    { id: 6, label: 'Disponibilité' },
    { id: 7, label: 'Région' },
  ];

  nextButton() {
    if (this.currentButton * this.buttonsPerPage < this.totalButtons) {
      this.currentButton++;
    }
    this.printAllStatistics(this.cohorte);
  }

  prevButton() {
    if (this.currentButton > 1) {
      this.currentButton--;
    }
    this.printAllStatistics(this.cohorte);
  }
}
